import { Injectable, NgZone } from '@angular/core';

import { IUser } from '../interfaces/user';
import { LoggerService } from './logger.service';
import { TaggedLogger } from './taggedLogger';
import { UserService } from './user.service';

const watchInterval = 1;

/**
 * Sets userService.currentUser on first load.
 * Watches for disparity between the user in local storage and the user in memory.
 *
 * todo: it doesn't perform the get again? so why bother?
 * todo: bump logging and see if it ever kicks,
 * I don't see a great use case here.
 *
 * todo: check what impersonating does to this scenario.
 */
@Injectable({ providedIn: 'root' })
export class CurrentUserWatchService {
  private logger: TaggedLogger;

  public loggedInUser: IUser;
  private timerId;

  public getLoggedUserPromise: Promise<IUser>;

  constructor(
    private userService: UserService,
    private zone: NgZone,
    loggerService: LoggerService,
  ) {
    this.logger = loggerService.taggedLogger('CurrentUserWatch');
  }

  init() {
    this.logger.trace('init()');
    this.getLoggedUserPromise = this.userService
      .getLoggedUser()
      .then((user: IUser) => {
        this.logger.trace('getLoggedUser():', user);
        this.loggedInUser = user;
        this.userService.currentUser = user;
        return user;
      })
      .catch((error) => {
        // log and rethrow to ensure this is working again.
        this.logger.error('Error getting logged user', error);
        throw error;
      });

    return this.getLoggedUserPromise;
  }

  watch() {
    this.logger.trace('watch()');
    if (!this.getLoggedUserPromise) {
      this.init().then(() => this.watch());
      return;
    }
    this.zone.runOutsideAngular(() => {
      this.getLoggedUserPromise.then((user: IUser) => {
        this.logger.trace('.then', user);

        if (this.timerId) {
          clearInterval(this.timerId);
        }

        this.logger.trace('Setting new interval');
        this.timerId = setInterval(() => this.checkUser(), watchInterval * 1000);
      });
    });
  }

  stop() {
    // Potential need for stop?
  }

  private checkUser() {
    this.zone.runOutsideAngular(() => {
      this.logger.trace('checkUser()');
      let user = this.userService.currentUser;
      if (!user || user.email != this.loggedInUser.email) {
        this.logger.warn('User disparity, reloading.');
        this.reload();
      }
    });
  }

  private reload() {
    this.zone.runOutsideAngular(() => {
      this.logger.trace('reload()');
      clearInterval(this.timerId); // todo: what's the point?
      window.location.reload();
    });
  }
}
